import { DialogData } from "./DialogData";

export class CashoutDialogData implements DialogData {

}
